import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewEncapsulation
} from '@angular/core';
import {Facet, FacetValue, ProductSearchPage} from '@spartacus/core';
import {ProductListComponentService, SearchCriteria} from '@spartacus/storefront';
import {Observable} from 'rxjs';
import {FacetSearchService} from '@app/services/facet-search.service';
import {SEARCH_ENABLED_THRESHOLD} from '../search-navigation-bar.component';
import {UntilDestroy} from '@ngneat/until-destroy';
import {DcpEddlSearchTrackingService} from '@app/services/analytics/EDDL/dcp-eddl-search-tracking.service';
import {HttpUrlEncodingCodec} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';

@UntilDestroy()
@Component({
  selector: 'dcp-facet-filter',
  templateUrl: './facet-filter.component.html',
  styleUrls: ['./facet-filter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FacetFilterComponent implements OnInit {
  @Input() facet: Facet;
  @Input() filteredFacetValues?: FacetValue[];
  /** An object which stores facet's scroll position and loading status */
  @Input() scrollPosition: { position: number; isLoading: boolean } = {position: 0, isLoading: false};
  @Output() scrollPositionChange = new EventEmitter<{ position: number; isLoading: boolean }>();
  @Output() valueChanged = new EventEmitter<string[]>();
  searchResult$: Observable<ProductSearchPage>;
  public currentScrollPosition: number;
  private previousValues: string[] = [];

  queryCodec: HttpUrlEncodingCodec;
  _activeDropdownFacets: string[] = [];
  hasActiveValue: (facetName: string, searchResultFacets: Facet[]) => boolean = this.facetSearchService.hasActiveValue;


  get activeDropdownFacets() {
    return this._activeDropdownFacets;
  }

  set activeDropdownFacets(df) {
    this.handleFacetChanged(df);
    this._activeDropdownFacets = df;
  }

  constructor(
    public cdr: ChangeDetectorRef,
    public facetSearchService: FacetSearchService,
    protected productListComponentService: ProductListComponentService,
    protected eddlSearchTrackingService: DcpEddlSearchTrackingService,
    protected el: ElementRef,
    protected renderer: Renderer2,
    protected router: Router,
    protected activatedRoute: ActivatedRoute,
  ) {
  }

  getSelectedFacetNames(): string[] {
    return this.facet.values
      .filter(facetValue => facetValue.selected)
      .map(facetValue => facetValue.name);
  }

  ngOnInit() {
    this.previousValues = this.getSelectedFacetNames();
    this.activeDropdownFacets = this.getSelectedFacetNames();
    this.searchResult$ = this.productListComponentService.model$;
    this.cdr.detectChanges();
  }

  onFilterSelect(e: CustomEvent): void {
    this.activeDropdownFacets = e.detail.selectedItems.map(item => item._state.label.replace(/<\/?b>/g, ''));
  };

  handleFacetChanged(values: string[]) {
    const toggleList: string[] = [
      ...values.filter(facetName => this.previousValues.indexOf(facetName) === -1),
      ...this.previousValues.filter(facetName => values.indexOf(facetName) === -1)
    ];
    this.previousValues = values;
    if (toggleList.length) {
      this.eddlSearchTrackingService.sortFilterOrPaginationHitEvent = true;
      this.valueChanged.emit(toggleList);
    }
  }

  isNeedToShowSearch(): boolean {
    return this.facet.values.length > SEARCH_ENABLED_THRESHOLD;
  }

  resetClick(e: CustomEvent): void {
    const restoredItems: string[] = e.detail.restoredItems.map(item => item._state.label.replace(/<\/?b>/g, ''));
    this.activeDropdownFacets = this.activeDropdownFacets.filter(selectedItem => restoredItems.indexOf(selectedItem) === -1);
  }

  route(queryParams: SearchCriteria): void {
    this.eddlSearchTrackingService.sortFilterOrPaginationHitEvent = true;
    this.router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge',
      relativeTo: this.activatedRoute,
    });
  }
}

